import { create } from 'zustand';

interface PreliminarState {
  /** Opt-in global: incluir periodos ABIERTO (preliminares) en los módulos EF. */
  incluirAbierto: boolean;

  setIncluirAbierto: (value: boolean) => void;

  reset: () => void;
}

const initialState = {
  incluirAbierto: false,
};

export const usePreliminarStore = create<PreliminarState>((set) => ({
  ...initialState,

  setIncluirAbierto: incluirAbierto => set({ incluirAbierto }),

  reset: () => set(initialState),
}));
